/**
 * All 23 regions of Chad, their capital cities, and other major cities.
 * Used across the app for filtering, mapping and listing.
 */

// Priority cities (still surfaced first across the UI)
export const PRIORITY_CITIES = [
  "N'Djamena",
  "Moundou",
  "Sarh",
  "Abéché",
  "Bongor",
  "Doba",
  "Kelo",
  "Amdjarass",
];

// 23 regions of Chad with their administrative capitals + main other cities of each region
// Order kept close to the user's requested order (north → south, then west → east).
export const CHAD_REGIONS = [
  { region: "N'Djamena", capital: "N'Djamena", cities: ["N'Djamena"] },
  { region: "Batha", capital: "Ati", cities: ["Ati", "Oum Hadjer"] },
  { region: "Chari-Baguirmi", capital: "Massenya", cities: ["Massenya", "Dourbali"] },
  { region: "Hadjer-Lamis", capital: "Massakory", cities: ["Massakory", "Bokoro"] },
  { region: "Wadi Fira", capital: "Biltine", cities: ["Biltine", "Iriba"] },
  { region: "Barh El Gazel", capital: "Moussoro", cities: ["Moussoro"] },
  { region: "Borkou", capital: "Faya-Largeau", cities: ["Faya-Largeau"] },
  { region: "Ennedi-Est", capital: "Amdjarass", cities: ["Amdjarass"] },
  { region: "Ennedi-Ouest", capital: "Fada", cities: ["Fada"] },
  { region: "Guéra", capital: "Mongo", cities: ["Mongo", "Bitkine"] },
  { region: "Kanem", capital: "Mao", cities: ["Mao"] },
  { region: "Lac", capital: "Bol", cities: ["Bol"] },
  { region: "Logone Occidental", capital: "Moundou", cities: ["Moundou"] },
  { region: "Logone Oriental", capital: "Doba", cities: ["Doba", "Goré"] },
  { region: "Mandoul", capital: "Koumra", cities: ["Koumra", "Kyabé"] },
  { region: "Mayo-Kebbi Est", capital: "Bongor", cities: ["Bongor"] },
  { region: "Mayo-Kebbi Ouest", capital: "Pala", cities: ["Pala"] },
  { region: "Moyen-Chari", capital: "Sarh", cities: ["Sarh"] },
  { region: "Ouaddaï", capital: "Abéché", cities: ["Abéché", "Adré"] },
  { region: "Salamat", capital: "Am Timan", cities: ["Am Timan", "Aboudeïa"] },
  { region: "Sila", capital: "Goz Beïda", cities: ["Goz Beïda"] },
  { region: "Tandjilé", capital: "Laï", cities: ["Laï", "Kelo"] },
  { region: "Tibesti", capital: "Bardaï", cities: ["Bardaï"] },
];

// 23 major cities explicitly requested for the navbar/footer section
export const MAJOR_CITIES = [
  "N'Djamena",
  "Moundou",
  "Sarh",
  "Abéché",
  "Kelo",
  "Koumra",
  "Pala",
  "Am Timan",
  "Bongor",
  "Mongo",
  "Doba",
  "Ati",
  "Laï",
  "Oum Hadjer",
  "Bitkine",
  "Mao",
  "Massakory",
  "Dourbali",
  "Adré",
  "Moussoro",
  "Bokoro",
  "Amdjarass",
  "Faya-Largeau",
];

// All cities the admin can choose from (capitals + every city listed in each region + priority + major)
const _all = new Set();
PRIORITY_CITIES.forEach((c) => _all.add(c));
MAJOR_CITIES.forEach((c) => _all.add(c));
CHAD_REGIONS.forEach((r) => {
  _all.add(r.capital);
  (r.cities || []).forEach((c) => _all.add(c));
});

export const ALL_CITIES = Array.from(_all);

// Other cities = everything except the 8 priority ones, alphabetically sorted
export const OTHER_CITIES = ALL_CITIES.filter(
  (c) => !PRIORITY_CITIES.includes(c)
).sort((a, b) => a.localeCompare(b, "fr"));
